import r from "./isObject.js";
import o from "./isArray.js";
import t from "./extend.js";
function e(e) {
  return r(e) ? o(e) ? e.slice() : t({}, e) : e;
}
export { e as default };